<template>
  <v-data-table
    :headers="headers"
    :items="telefonesFormatados"
    sort-by="tipo"
    hide-default-footer
		item-key="valor"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title class="mr-3">Telefones</v-toolbar-title>
        <v-spacer/>
				<v-btn
					color="primary"
					dark
					text
					@click="criarTelefone"
				> Incluir Telefone </v-btn>
      </v-toolbar>
			<v-dialog v-model="dialog" max-width="500px">
				<v-card v-if="dialog">
					<v-card-title>
						<span class="headline">{{ formTitle }}</span>
					</v-card-title>

					<v-card-text>
						<v-select
							v-model="telefoneEditado.tipo"
							label="Tipo"
							:items="tiposDeTelefone"
							required
							:rules="[ obrigatorio ]"
						/>
						<v-text-field
							v-model="telefoneEditado.valor"
							label="Número"
							required
							:rules="[ obrigatorio ]"
							v-mask="['(##) ####-####', '(##) #####-####']"
						/>
					</v-card-text>

					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="primary" text @click="close">Cancelar</v-btn>
						<v-btn color="primary" text @click="save">Salvar</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="() => editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="() => deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
  </v-data-table>
</template>

<script lang="ts">
export default {
	model: {
		prop: 'telefones',
	},
}
</script>

<script setup lang="ts">
import { computed, PropType, ref } from 'vue'
import { Telefone } from '@/../common/types/Telefone'
import { tiposDeTelefone } from '@/shareds/sharedsTelefone'
import { obrigatorio } from '@/shareds/regras'
import { mask as vMask } from 'vue-the-mask'
import { formatarTelefone } from '../../../shareds/formatadores'

type TelefoneEditado = Telefone & { valorEditado: string }

const props = defineProps({
	telefones: {
		type: Array as PropType<Telefone[]>,
		default: () => [],
	},
})

const emit = defineEmits<{
	(e: 'input', telefones: Telefone[]): void
}>()

const headers = [
	{ text: 'Tipo', value: 'tipo' },
	{ text: 'Número', value: 'valorEditado' },
	{ text: 'Ações', value: 'action', sortable: false },
]
const dialog = ref(false)
const indiceEdicao = ref(-1)
const telefoneEditado = ref<TelefoneEditado>({
	tipo: 'Outro',
	valor: '',
	valorEditado: '',
})
const telefoneDefault: TelefoneEditado = {
	tipo: 'Outro',
	valor: '',
	valorEditado: '',
}

function criarTelefone() {
	telefoneEditado.value = {
		...telefoneDefault,
	}
	dialog.value = true
	indiceEdicao.value = -1
}

const telefonesFormatados = computed(() => props.telefones.map(telefone => ({
	...telefone,
	valorEditado: formatarTelefone(telefone.valor),
})))

const formTitle = computed(() => indiceEdicao.value === -1 ? 'Novo Telefone' : 'Editar Telefone')

function editItem(item: TelefoneEditado) {
	telefoneEditado.value = { ...item }
	indiceEdicao.value = telefonesFormatados.value.indexOf(item)
	dialog.value = true
}

function deleteItem(item: TelefoneEditado) {
	if  (!window.confirm(`Deseja mesmo remover o ${item.valor}?`)) return
	const index = props.telefones.findIndex(({ valor }) => valor === item.valor)
	const telefones = [ ...props.telefones ]
	telefones.splice(index, 1)
	emit('input', telefones)
}

function close() {
	dialog.value = false
}

function save() {
	const telefones = [ ...props.telefones ]
	const { valorEditado, ...novoValor} = telefoneEditado.value
	if (indiceEdicao.value > -1) {
		telefones.splice(indiceEdicao.value, 1, novoValor)
	} else {
		telefones.push(novoValor)
	}
	emit('input', telefones)
	close()
}
</script>
